"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCardHeader = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var colors_1 = __importDefault(require("../../tokens/colors"));
var spacing_1 = __importDefault(require("../../tokens/spacing"));
/**
 * For use within a <TableCard /> component only.
 *
 * We add a padding-bottom because this component will always exist with some content below.
 * Also, this value is inconsistent in Figma, some are 20px, 32 px, 24px. After some discussions
 * with design, we agreed to use 24px and design agreed to change all instances of this spacing
 * to be consistently 24px.
 * */
exports.TableCardHeader = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  padding-bottom: ", ";\n  border-bottom: 1px solid ", ";\n"])), spacing_1.default.space24, colors_1.default.n70);
var templateObject_1;
//# sourceMappingURL=index.js.map